import {InitResponseDTO} from '@/domain/dtos/InitResponseDTO';
import {httpPost} from '@/shared/api/serve/httpPost';

export async function init(payload: {uuid: string; campaign_info?: string}) {
  const {data} = await httpPost<InitResponseDTO>('init', payload);

  return data.result;
}
